module.exports = __webpack_public_path__ + "blue1.64e66e91.png";